import { apiRequest } from "../apiRequest";

export async function resendConfirmationEmail(contacts: string[]) {
  await apiRequest({ url: "contactConfirmations", method: "POST", body: JSON.stringify({ contacts }) });
}
